import '.a{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.aq{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.ap{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.gr{justify-content:stretch;}.ssr-plugin'
import '.bm{position:sticky;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.br{z-index:10;}.ssr-plugin'
import '.gc{padding-block:1rem;}.ssr-plugin'
import '.gd{height:3rem;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.gs{margin-bottom:0px;}.ssr-plugin'
import '.gt{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fs{margin-top:2rem;}.ssr-plugin'
import '.gu{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="a r aq b e2"
      >
        <div className="ap a t aq b"
        >
          <div className="ab a b gr bm bn br e2"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="gc gd a ae t ah"
            >
              <styled.span className="gs"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gt a b r fs gu ab"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
